import cn from 'clsx'

import { Link } from 'react-router-dom'
import { Message } from '@components/shared/Message'

const AuthForm = ({
    className,
    submitButtonClassName = 'btn-outline',
    viewModel,
    onSubmit,
    submitButtonText,
    submitButtonDisabled,
    cancelButtonText,
    cancelButtonLink = '',
    cancelButtonClass = 'btn-primary btn-outline',
    cancelButtonDisabled,
    onCancelButtonClick = () => {},
    children,
}) => {
    
    return (
        
        <div className={cn('flex flex-col items-center justify-center min-h-screen', className)}>
            
            <div className="w-full max-w-lg py-20 rounded-lg px-20 bg-base-300/10 bg-opacity-30 mx-auto sm:my-8">
                
                <div className="flex items-center justify-center w-11/12 mx-auto mb-4">
                    <img src="/img/logo-medium.png" width="100%" alt="" />
                </div>
                
                <form className="block w-full mt-10 mb-5 login-form" onSubmit={onSubmit}>
                    
                    {viewModel.message && (
                        <Message
                            className="mb-3"
                            message={viewModel.message}
                            onDismiss={() => viewModel.setMessage()} />
                    )}
                    
                    {children}
                    
                    {submitButtonText?.length > 0 && (
                        <button
                            className={cn('mb-3 btn w-full btn-lg btn-primary', submitButtonClassName)}
                            type="submit"
                            disabled={submitButtonDisabled}
                            data-test-id="AuthFormSubmitButton">
                            {submitButtonText}
                        </button>
                    )}
                    
                    {cancelButtonText?.length > 0 && (
                        <Link
                            to={cancelButtonLink}
                            onClick={onCancelButtonClick}
                            data-test-id="AuthFormCancelButton">
                            <input
                                className={`mb-3 btn w-full btn-lg ${cancelButtonClass}`}
                                type="button"
                                value={cancelButtonText}
                                disabled={cancelButtonDisabled}>
                            </input>
                        </Link>
                    )}
                
                </form>
            
            </div>
        
        </div>
        
    )
    
}

export default AuthForm
